import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// REDUX
import { useLazyGetLeadingZeroesQuery } from "../../../redux/LeadingZeroes/leadingZeroesAPI";
// INTERFACES
import { LeadingZeroeInterface } from "../../../interfaces/LeadingZeroes.interface";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";

function FormSelectLeadingZeroes({
	inputValue,
	inputOnChange,
	inputLabelName,
}: {
	inputValue: string;
	inputLabelName: string;
	inputOnChange: (id: string) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [leadingZeroes, setLeadingZeroes] = useState<LeadingZeroeInterface[]>(
		[],
	);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const [
		triggerGetLeadingZeroes,
		{ data: dataGetLeadingZeroes, isLoading: isLoadingGetLeadingZeroes },
	] = useLazyGetLeadingZeroesQuery();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const getInitData = async () => {
		const token = await GETJwtToken();
		triggerGetLeadingZeroes({
			token,
		});
	};

	const onChangeInputLeadingZeroe = (id: string) => {
		const index = leadingZeroes.findIndex((item: any) => item.id === id);
		if (index >= 0) {
			inputOnChange(leadingZeroes[index].id);
		}
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		getInitData();
	}, []);

	useEffect(() => {
		if (dataGetLeadingZeroes && dataGetLeadingZeroes.data) {
			setLeadingZeroes(dataGetLeadingZeroes.data);
		}
	}, [dataGetLeadingZeroes]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>{inputLabelName}</span>
				</div>
				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						onChange={(e: any) => {
							onChangeInputLeadingZeroe(e);
						}}
						value={inputValue}
						loading={isLoadingGetLeadingZeroes}
					>
						{leadingZeroes.map((item: any) => (
							<Option key={item.id} value={item.id}>
								{item.name}
							</Option>
						))}
					</Select>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}

export default FormSelectLeadingZeroes;
